import React, { Component } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  Row,
  Col,
  Container,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Label,
  InputGroupButtonDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Form,
  Table,
} from "reactstrap";
import axios from "axios";
import { toast } from "react-toastify";

class Users extends Component {
  state = {
    activeTab: "2",
    splitButtonOpen: false,
    employer: "CHECKOFF",
    email: "",
    name: "",
    password: "",
    cpassword: "",
    organisations: [],
    users: "",
    recruiters: [],
    dse: [],
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  componentDidMount = () => {
    const organisations = [
      {
        name: "CHECKOFF",
      },
    ];
    this.getRecruiters();
    this.getDSE();
    this.setState({ organisations });

    // not needed, //moving from lendlot
    // axios.get('/api/getCode/32').then((resp) => {
    //   let name;
    //   console.log(resp.data);
    //   resp.data.map((recruiter) => {
    //     name = recruiter.name.split(',');
    //     organisations.push({
    //       name: name[0].toUpperCase(),
    //     });
    //   });
    //   // remove not applicablefrom ist
    //   const neworg = organisations.filter(item => !item.name.includes('NOT APPLICABLE'));
    //   this.setState({ organisations: neworg });
    // }).catch((err) => {
    //   console.error(err.response);
    // });
    this.getUsers();
  };

  getUsers = () => {
    axios
      .get("/api/getUsers", {
        headers: { Authorization: localStorage.getItem("token") },
      })
      .then((resp) => {
        this.setState({ users: resp.data });
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  toggleSplit = () => {
    this.setState({
      splitButtonOpen: !this.state.splitButtonOpen,
    });
  };

  submitForm = (e) => {
    const { email, password, name, cpassword } = this.state;
    e.preventDefault();
    if (
      email !== "" &&
      password !== "" &&
      name !== "" &&
      password === cpassword
    ) {
      axios
        .post(
          "/api/registerUser",
          { ...this.state },
          { headers: { Authorization: localStorage.getItem("token") } }
        )
        .then((resp) => {
          // console.log(resp.data);
          this.toggle("1");
          this.getUsers();
        })
        .catch((err) => {
          console.error(err.response);
        });
    }
  };
  toggleDelete = (user) => {
    if(!user) return toast('error occured')
    toast('processing')
      axios
        .get(
          `/api/toggleDelete/${user}`,
          { headers: { Authorization: localStorage.getItem("token") } }
        )
        .then((resp) => {
          toast('successful')
          this.getUsers();
        })
        .catch((err) => {
          toast('an error occured')
          console.error(err.response);
        });
    
  };
  getDSE = async () => {
    try {
      const { data: dse } = await axios.get("/api/getDSE", {
        headers: { Authorization: localStorage.getItem("token") },
      });
      this.setState({ dse });
      //  console.log(recruiters);
      //  alert('recruiter created successfully')
    } catch (error) {
      console.log(error);
      alert("an error occured");
    }
  };

  createDSE = (e) => {
    e.preventDefault();

    // const {
    //   email, password, name, cpassword,
    // } = this.state;
    // console.log(this.state);

    // if (this.state.recruiterName && this.state.recruiterDTI && this.state.recruiterInterest && this.state.recruiterRepayment && this.state.recruiterMaximumAmount && this.state.recruiterTenor) {
    (async () => {
      try {
        await axios.post(
          "/api/createDSE",
          {
            DSEId: this.state.DSEId,
            name: this.state.DSEName,
          },
          { headers: { Authorization: localStorage.getItem("token") } }
        );
        this.getDSE();
        alert(`dse ${this.state.DSEId ? "updated" : "created"} successfully`);

        this.setState({ DSEId: null, DSEName: "" });
      } catch (error) {
        console.log(error);
        alert("an error occured");
      }
    })();

    // console.log('ok')
    // Object.entries(this.state).map(([key, value]) => {

    // })
    // } else {
    //   alert('Fill all fields')
    // }
    // if (email !== '' && password !== '' && name !== '' && (password === cpassword)) {
    //   axios.post('/api/createRecruiter', { ...this.state }).then((resp) => {
    //     console.log(resp.data);
    //     this.toggle('1');
    //     this.getUsers();
    //   }).catch((err) => {
    //     console.error(err.response);
    //   });
    // }
  };

  getRecruiters = async () => {
    try {
      const { data: recruiters } = await axios.get("/api/getRecruiters", {
        headers: { Authorization: localStorage.getItem("token") },
      });
      this.setState({ recruiters });
      //  console.log(recruiters);
      //  alert('recruiter created successfully')
    } catch (error) {
      console.log(error);
      alert("an error occured");
    }
  };

  createRecruiter = (e) => {
    e.preventDefault();

    // const {
    //   email, password, name, cpassword,
    // } = this.state;
    // console.log(this.state);

    // if (this.state.recruiterName && this.state.recruiterDTI && this.state.recruiterInterest && this.state.recruiterRepayment && this.state.recruiterMaximumAmount && this.state.recruiterTenor) {
    (async () => {
      try {
        await axios.post(
          "/api/createRecruiter",
          {
            branchPrefix: this.state.branchPrefix,
            feeType: this.state.recruiterFeeType,
            fee: this.state.recruiterFee,
            recruiterId: this.state.recruiterId,
            name: this.state.recruiterName,
            returningDti: this.state.recruiterReturningDTI,
            returningInterest: this.state.recruiterReturningInterest,
            returningTenor: this.state.recruiterReturningTenor,
            dti: this.state.recruiterDTI,
            interest: this.state.recruiterInterest,
            tenor: this.state.recruiterTenor,
            repaymentDays: this.state.recruiterRepaymentDays,
            maximum: this.state.recruiterMaximumAmount,
            minimum: this.state.recruiterMinimumAmount,
            workingStatus: this.state.recruiterWorkingStatus,
            email: this.state.recruiterEmail,
            branch: this.state.recruiterBranch,
            product: this.state.recruiterProduct,
          },
          { headers: { Authorization: localStorage.getItem("token") } }
        );
        this.getRecruiters();
        alert(
          `recruiter ${
            this.state.recruiterId ? "updated" : "created"
          } successfully`
        );

        this.setState({ recruiterId: null, recruiterName: "" });
      } catch (error) {
        console.log(error);
        alert("an error occured");
      }
    })();

    // console.log('ok')
    // Object.entries(this.state).map(([key, value]) => {

    // })
    // } else {
    //   alert('Fill all fields')
    // }
    // if (email !== '' && password !== '' && name !== '' && (password === cpassword)) {
    //   axios.post('/api/createRecruiter', { ...this.state }).then((resp) => {
    //     console.log(resp.data);
    //     this.toggle('1');
    //     this.getUsers();
    //   }).catch((err) => {
    //     console.error(err.response);
    //   });
    // }
  };

  render() {
    return (
      <Container>
        <Row>
          <Col md={6} className="mx-auto">
            <Nav pills>
              <NavItem>
                <NavLink
                  active={this.state.activeTab === "1"}
                  onClick={() => {
                    this.toggle("1");
                  }}
                >
                  Users
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  active={this.state.activeTab === "2"}
                  onClick={() => {
                    this.toggle("2");
                  }}
                >
                  Setup User
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  active={this.state.activeTab === "3"}
                  onClick={() => {
                    this.toggle("3");
                  }}
                >
                  Setup Recruiters
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  active={this.state.activeTab === "4"}
                  onClick={() => {
                    this.toggle("4");
                  }}
                >
                  DSE
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <Row className="my-5">
          <Col md={12}>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <Row>
                  <Col md={12}>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Organisation</th>
                          <th>Email</th>
                          <th/>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.users
                          ? this.state.users.map((item) => (
                              <tr>
                                <td> {item.name}</td>
                                <td> {item.employer}</td>
                                <td>{item.email}</td>
                                <td> <Button
                    onClick={()=>this.toggleDelete(item._id)}
                    size="sm"
                    color="primary"
                  >
                   {item.isDeleted ? 'Activate':'Deactivate'}
                  </Button></td>
                                
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </TabPane>

              <TabPane tabId="2">
                <Row className="justify-content-center">
                  <Col sm="6">
                    <Form onSubmit={this.submitForm}>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupButtonDropdown
                            addonType="prepend"
                            isOpen={this.state.splitButtonOpen}
                            toggle={this.toggleSplit}
                          >
                            <Button type="button" outline>
                              {this.state.employer}
                            </Button>
                            <DropdownToggle split outline />
                            <DropdownMenu>
                              {this.state.organisations
                                ? this.state.organisations.map((org) => (
                                    <DropdownItem
                                      onClick={() => {
                                        this.setState({ employer: org.name });
                                      }}
                                      key={org.name}
                                    >
                                      {org.name}
                                    </DropdownItem>
                                  ))
                                : null}
                            </DropdownMenu>
                          </InputGroupButtonDropdown>
                          <Input
                            placeholder="Name"
                            type="text"
                            onChange={(e) => {
                              this.setState({ name: e.target.value });
                            }}
                            value={this.state.name}
                          />
                        </InputGroup>
                      </FormGroup>{" "}
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Email
                          </InputGroupAddon>
                          <Input
                            type="email"
                            onChange={(e) => {
                              this.setState({ email: e.target.value });
                            }}
                            value={this.state.email}
                          />
                        </InputGroup>
                      </FormGroup>{" "}
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Password
                          </InputGroupAddon>
                          <Input
                            type="password"
                            onChange={(e) => {
                              this.setState({ password: e.target.value });
                            }}
                            value={this.state.password}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Confirm Password
                          </InputGroupAddon>
                          <Input
                            type="password"
                            onChange={(e) => {
                              this.setState({ cpassword: e.target.value });
                            }}
                            value={this.state.cpassword}
                          />
                        </InputGroup>
                      </FormGroup>
                      <Row className="justify-content-center my-5">
                        <Button
                          type="submit"
                          color="info"
                          className="btnprimary"
                        >
                          Submit
                        </Button>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="3">
                <Row className="justify-content-center">
                  <Col sm="6">
                    <Form onSubmit={this.createRecruiter}>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Name
                          </InputGroupAddon>
                          <Input
                            required
                            type="text"
                            onChange={(e) => {
                              this.setState({ recruiterName: e.target.value });
                            }}
                            value={this.state.recruiterName}
                          />
                        </InputGroup>
                      </FormGroup>

                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Fee
                          </InputGroupAddon>
                          <Input
                            required
                            onChange={(e) => {
                              this.setState({ recruiterFee: e.target.value });
                            }}
                            value={this.state.recruiterFee}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Fee Type
                          </InputGroupAddon>
                          <Input
                            required
                            onChange={(e) => {
                              this.setState({
                                recruiterFeeType: e.target.value,
                              });
                            }}
                            value={this.state.recruiterFeeType}
                            type="select"
                            name="select"
                            id="exampleSelect"
                          >
                            <option value="">select fee type</option>
                            <option value="flat">Flat</option>
                            <option value="percentage">Percentage</option>
                          </Input>
                        </InputGroup>
                      </FormGroup>

                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Maximum Amount
                          </InputGroupAddon>
                          <Input
                            required
                            type="number"
                            onChange={(e) => {
                              this.setState({
                                recruiterMaximumAmount: e.target.value,
                              });
                            }}
                            value={this.state.recruiterMaximumAmount}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Minimum Amount
                          </InputGroupAddon>
                          <Input
                            required
                            type="number"
                            onChange={(e) => {
                              this.setState({
                                recruiterMinimumAmount: e.target.value,
                              });
                            }}
                            value={this.state.recruiterMinimumAmount}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Tenor
                          </InputGroupAddon>
                          <Input
                            required
                            type="number"
                            onChange={(e) => {
                              this.setState({ recruiterTenor: e.target.value });
                            }}
                            value={this.state.recruiterTenor}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            DTI
                          </InputGroupAddon>
                          <Input
                            required
                            type="text"
                            onChange={(e) => {
                              this.setState({ recruiterDTI: e.target.value });
                            }}
                            value={this.state.recruiterDTI}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Interest
                          </InputGroupAddon>
                          <Input
                            required
                            type="text"
                            onChange={(e) => {
                              this.setState({
                                recruiterInterest: e.target.value,
                              });
                            }}
                            value={this.state.recruiterInterest}
                          />
                        </InputGroup>
                      </FormGroup>

                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Returning Tenor
                          </InputGroupAddon>
                          <Input
                            required
                            type="number"
                            onChange={(e) => {
                              this.setState({
                                recruiterReturningTenor: e.target.value,
                              });
                            }}
                            value={this.state.recruiterReturningTenor}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Returning DTI
                          </InputGroupAddon>
                          <Input
                            required
                            type="text"
                            onChange={(e) => {
                              this.setState({
                                recruiterReturningDTI: e.target.value,
                              });
                            }}
                            value={this.state.recruiterReturningDTI}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Returning Interest
                          </InputGroupAddon>
                          <Input
                            required
                            type="text"
                            onChange={(e) => {
                              this.setState({
                                recruiterReturningInterest: e.target.value,
                              });
                            }}
                            value={this.state.recruiterReturningInterest}
                          />
                        </InputGroup>
                      </FormGroup>

                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Employer Email
                          </InputGroupAddon>
                          <Input
                            required
                            type="email"
                            onChange={(e) => {
                              this.setState({ recruiterEmail: e.target.value });
                            }}
                            value={this.state.recruiterEmail}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Repayment Days
                          </InputGroupAddon>
                          <Input
                            required
                            type="number"
                            onChange={(e) => {
                              this.setState({
                                recruiterRepaymentDays: e.target.value,
                              });
                            }}
                            value={this.state.recruiterRepaymentDays}
                          />
                        </InputGroup>
                      </FormGroup>

                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Loandisk Product ID
                          </InputGroupAddon>
                          <Input
                            required
                            type="number"
                            onChange={(e) => {
                              this.setState({
                                recruiterProduct: e.target.value,
                              });
                            }}
                            value={this.state.recruiterProduct}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Loandisk Branch ID
                          </InputGroupAddon>
                          <Input
                            required
                            type="number"
                            onChange={(e) => {
                              this.setState({
                                recruiterBranch: e.target.value,
                              });
                            }}
                            value={this.state.recruiterBranch}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Working Status
                          </InputGroupAddon>
                          <Input
                            required
                            onChange={(e) => {
                              this.setState({
                                recruiterWorkingStatus: e.target.value,
                              });
                            }}
                            value={this.state.recruiterWorkingStatus}
                            type="select"
                            name="select"
                            id="exampleSelect"
                          >
                            <option value="">select working status</option>
                            <option value="government employee">
                              Government Employee
                            </option>
                            <option value="private sector employee">
                              Private Sector Employee
                            </option>
                          </Input>
                        </InputGroup>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            Branch Prefix
                          </InputGroupAddon>
                          <Input
                            required
                            type="text"
                            onChange={(e) => {
                              this.setState({ branchPrefix: e.target.value });
                            }}
                            value={this.state.branchPrefix}
                          />
                        </InputGroup>
                      </FormGroup>

                      <Row className="justify-content-center my-5">
                        <Button
                          type="submit"
                          color="info"
                          className="btnprimary"
                        >
                          {this.state.recruiterId ? "Update" : "Create"}{" "}
                          Recruiter
                        </Button>
                        {this.state.recruiterId && (
                          <Button
                            style={{ marginLeft: 10 }}
                            onClick={() =>
                              this.setState({
                                recruiterId: null,
                                recruiterName: "",
                              })
                            }
                            type="button"
                            color="danger"
                          >
                            Cancel
                          </Button>
                        )}
                      </Row>
                    </Form>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          <th />
                          <th>ID</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Product</th>
                          <th>Branch</th>
                          <th>Fee</th>
                          <th>Fee Type</th>
                          <th>Repayment Days</th>
                          <th>DTI</th>
                          <th>Interest</th>
                          <th>Tenor</th>
                          <th>Returning DTI</th>
                          <th>Returning Interest</th>
                          <th>Returning Tenor</th>
                          <th>Maximum Amount</th>
                          <th>Minimum Amount</th>
                          <th>Branch Prefix</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.recruiters &&
                        Array.isArray(this.state.recruiters)
                          ? this.state.recruiters.map((item) => (
                              <tr>
                                <td>
                                  <Button
                                    color="info"
                                    onClick={() =>
                                      this.setState({
                                        branchPrefix: item.branchPrefix,
                                        recruiterFeeType: item.feeType,
                                        recruiterFee: item.fee,
                                        recruiterName: item.name,
                                        recruiterReturningDTI:
                                          item.returningDti,
                                        recruiterReturningInterest:
                                          item.returningInterest,
                                        recruiterReturningTenor:
                                          item.returningTenor,
                                        recruiterDTI: item.dti,
                                        recruiterInterest: item.interest,
                                        recruiterTenor: item.tenor,
                                        recruiterRepaymentDays:
                                          item.repaymentDays,
                                        recruiterMinimumAmount: item.minimum,
                                        recruiterMaximumAmount: item.maximum,
                                        recruiterWorkingStatus:
                                          item.workingStatus,
                                        recruiterEmail: item.email,
                                        recruiterBranch: item.branch,
                                        recruiterProduct: item.product,
                                        recruiterId: item._id,
                                      })
                                    }
                                    size="sm"
                                  >
                                    Edit
                                  </Button>
                                </td>
                                <td> {item._id}</td>
                                <td> {item.name}</td>
                                <td> {item.email}</td>
                                <td>{item.product}</td>
                                <td>{item.branch}</td>
                                <td>{item.fee}</td>
                                <td>{item.feeType}</td>
                                <td>{item.repaymentDays}</td>
                                <td>{item.dti}</td>
                                <td>{item.interest}</td>
                                <td>{item.tenor}</td>
                                <td>{item.returningDti}</td>
                                <td>{item.returningInterest}</td>
                                <td>{item.returningTenor}</td>
                                <td>{item.maximum}</td>
                                <td>{item.minimum}</td>
                                <td>{item.branchPrefix}</td>
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </TabPane>

              <TabPane tabId="4">
                <Row className="justify-content-center">
                  <Col sm="6">
                    <Form onSubmit={this.createDSE}>
                      <FormGroup>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            DSE Name
                          </InputGroupAddon>
                          <Input
                            required
                            type="text"
                            onChange={(e) => {
                              this.setState({ DSEName: e.target.value });
                            }}
                            value={this.state.DSEName}
                          />
                        </InputGroup>
                      </FormGroup>

                      <Row className="justify-content-center my-5">
                        <Button
                          type="submit"
                          color="info"
                          className="btnprimary"
                        >
                          {this.state.DSEId ? "Update" : "Create"} DSE
                        </Button>
                        {this.state.DSEId && (
                          <Button
                            style={{ marginLeft: 10 }}
                            onClick={() =>
                              this.setState({
                                DSEId: null,
                                DSEName: "",
                              })
                            }
                            type="button"
                            color="danger"
                          >
                            Cancel
                          </Button>
                        )}
                      </Row>
                    </Form>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          <th />
                          <th>Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.dse && Array.isArray(this.state.dse)
                          ? this.state.dse.map((item) => (
                              <tr>
                                <td>
                                  <Button
                                    color="info"
                                    onClick={() =>
                                      this.setState({
                                        DSEName: item.name,
                                        DSEId: item._id,
                                      })
                                    }
                                    size="sm"
                                  >
                                    Edit
                                  </Button>
                                </td>
                                <td> {item.name}</td>
                              </tr>
                            ))
                          : null}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Users;
